var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMakeLonger(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.63257 3.80457H16.3597C16.8519 3.80457 17.2441 3.38159 17.2441 2.8971C17.2441 2.39722 16.8596 1.99731 16.3597 1.99731H1.63257C1.1327 1.99731 0.748169 2.4126 0.748169 2.8971C0.748169 3.3739 1.14038 3.80457 1.63257 3.80457ZM1.63257 7.83435H16.3597C16.8519 7.83435 17.2441 7.41138 17.2441 6.92688C17.2441 6.4347 16.8596 6.0271 16.3597 6.0271H1.63257C1.1327 6.0271 0.748169 6.44238 0.748169 6.92688C0.748169 7.40368 1.14038 7.83435 1.63257 7.83435ZM1.63257 11.8718H16.3597C16.8519 11.8718 17.2441 11.4489 17.2441 10.9644C17.2441 10.4645 16.8596 10.0646 16.3597 10.0646H1.63257C1.1327 10.0646 0.748169 10.4799 0.748169 10.9644C0.748169 11.4411 1.14038 11.8718 1.63257 11.8718ZM1.63257 15.9017H9.49988C9.99207 15.9017 10.3843 15.4787 10.3843 14.9941C10.3843 14.5019 9.99975 14.0943 9.49988 14.0943H1.63257C1.1327 14.0943 0.748169 14.5097 0.748169 14.9941C0.748169 15.471 1.14038 15.9017 1.63257 15.9017Z",
    fill: "black",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMakeLonger);
export default __webpack_public_path__ + "static/media/make-longer.27d225ccb66e011fae73282803619a59.svg";
export { ForwardRef as ReactComponent };